import {
  Box,
  Center,
  Spinner
} from "@chakra-ui/react";
const LoadingScreen = () => {
  return (
    <Box pos="absolute" inset="0" bg="bg/80">
      <Center h="full">
        <Spinner color="red.500" />
      </Center>
    </Box>
  );
};

export default LoadingScreen;
